import { render, staticRenderFns } from "./TabDrawer.vue?vue&type=template&id=1c37e2f0&"
import script from "./TabDrawer.vue?vue&type=script&lang=js&"
export * from "./TabDrawer.vue?vue&type=script&lang=js&"
import style0 from "./TabDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports